module Meevo.Plugins.DashboardGoals {

    import GoalCategoryEnum = Meevo.Components.Goals.GoalCategoryEnum;
    import IGoalColumn = Meevo.Components.Goals.IGoalColumn;

    enum ViewTypesEnum {
        DataOnly = 0,
        Graphs,
        Charts,
    }

    const CURRENT_YEAR = new Date().getFullYear();
    const DATA_VIEWS = [
        {label: 'Data only', value: ViewTypesEnum.DataOnly},
        { label: 'Charts', value: ViewTypesEnum.Charts }
    ];

    interface IFiterGoalType {
        goalCategory?: GoalCategoryEnum;
        goalDateRange?: GoalDateRangeEnum;
    }

    interface IFilterObject {
        year: number;
        employeeId: string;
        departmentId: string;
        goalTypes: Array<IFiterGoalType>;
        isDataView: boolean;
    }

    const DEFAULT_FILTER_CRITERIA: IFilterObject = {
        year: CURRENT_YEAR,
        employeeId: null,
        departmentId: '',
        goalTypes: [],
        isDataView: false
    };

    export enum GoalDateRangeEnum {
        SpecificYear = 0,
        Today = 1,
        Yesterday = 2,
        Tomorrow = 3,
        ThisWeek = 4,
        LastWeek = 5,
        LastMonth = 6,
        ThisMonth = 7,
        NextMonth = 8,
        YearToDate = 9,
        LastTwelveMonths = 10
    };

    export const GOAL_DATE_RANGES = [
        {
            value: GoalDateRangeEnum.Today,
            label: 'LABEL_TODAY'
        },
        {
            value: GoalDateRangeEnum.Yesterday,
            label: 'LABEL_YESTERDAY'
        },
        {
            value: GoalDateRangeEnum.Tomorrow,
            label: 'LABEL_TOMORROW'
        },
        {
            value: GoalDateRangeEnum.ThisWeek,
            label: 'LABEL_THIS_WEEK'
        },
        {
            value: GoalDateRangeEnum.LastWeek,
            label: 'LABEL_LAST_WEEK'
        },
        {
            value: GoalDateRangeEnum.LastMonth,
            label: 'LABEL_LAST_MONTH'
        },
        {
            value: GoalDateRangeEnum.ThisMonth,
            label: 'LABEL_THIS_MONTH'
        },
        {
            value: GoalDateRangeEnum.NextMonth,
            label: 'LABEL_NEXT_MONTH'
        },
        {
            value: GoalDateRangeEnum.YearToDate,
            label: 'LABEL_YTD'
        },
        {
            value: GoalDateRangeEnum.LastTwelveMonths,
            label: 'LABEL_LAST_TWELVE_MONTHS'
        },
        {
            value: GoalDateRangeEnum.SpecificYear,
            label: 'LABEL_SELECTED_YEAR'
        }
    ];

    export const DATE_RANGES = {
        [GoalDateRangeEnum.Today]: 'LABEL_TODAY',
        [GoalDateRangeEnum.Yesterday]: 'LABEL_YESTERDAY',
        [GoalDateRangeEnum.Tomorrow]: 'LABEL_TOMORROW',
        [GoalDateRangeEnum.ThisWeek]: 'LABEL_THIS_WEEK',
        [GoalDateRangeEnum.LastWeek]: 'LABEL_LAST_WEEK',
        [GoalDateRangeEnum.LastMonth]: 'LABEL_LAST_MONTH',
        [GoalDateRangeEnum.ThisMonth]: 'LABEL_THIS_MONTH',
        [GoalDateRangeEnum.NextMonth]: 'LABEL_NEXT_MONTH',
        [GoalDateRangeEnum.LastTwelveMonths]: 'LABEL_LAST_TWELVE_MONTHS',
        [GoalDateRangeEnum.YearToDate]: 'LABEL_YTD',
        [GoalDateRangeEnum.SpecificYear]: 'LABEL_SELECTED_YEAR'
    };


    export const GOAL_CATEGORIES_DATERANGES = {
        sales: [ // Service, Retail, GiftCards
            GoalDateRangeEnum.Today,
            GoalDateRangeEnum.Yesterday,
            GoalDateRangeEnum.Tomorrow,
            GoalDateRangeEnum.ThisWeek,
            GoalDateRangeEnum.LastWeek,
            GoalDateRangeEnum.LastMonth,
            GoalDateRangeEnum.NextMonth,
            GoalDateRangeEnum.ThisMonth,
            GoalDateRangeEnum.LastTwelveMonths,
            GoalDateRangeEnum.YearToDate,
            GoalDateRangeEnum.SpecificYear
        ],
        ratings: [ // FiveStarRating, FrequencyOfVisit, NewClientsPerMonth
            GoalDateRangeEnum.LastTwelveMonths,
            GoalDateRangeEnum.YearToDate,
            GoalDateRangeEnum.SpecificYear
        ],
        retention: [// retentions
            GoalDateRangeEnum.YearToDate,
            GoalDateRangeEnum.SpecificYear
        ],
        rates: [ // Memberships
            GoalDateRangeEnum.Today,
            GoalDateRangeEnum.Yesterday,
            GoalDateRangeEnum.Tomorrow,
            GoalDateRangeEnum.ThisWeek,
            GoalDateRangeEnum.LastWeek,
            GoalDateRangeEnum.LastMonth,
            GoalDateRangeEnum.NextMonth,
            GoalDateRangeEnum.ThisMonth,
            GoalDateRangeEnum.YearToDate,
            GoalDateRangeEnum.SpecificYear
        ],
        RequestRate: [ //RequestRate
            GoalDateRangeEnum.Today,
            GoalDateRangeEnum.Yesterday,
            GoalDateRangeEnum.Tomorrow,
            GoalDateRangeEnum.ThisWeek,
            GoalDateRangeEnum.LastWeek,
            GoalDateRangeEnum.LastMonth,
            GoalDateRangeEnum.NextMonth,
            GoalDateRangeEnum.ThisMonth,
            GoalDateRangeEnum.LastTwelveMonths,
            GoalDateRangeEnum.YearToDate,
            GoalDateRangeEnum.SpecificYear
        ],
        rebook: [
            GoalDateRangeEnum.ThisWeek,
            GoalDateRangeEnum.LastWeek,
            GoalDateRangeEnum.LastMonth,
            GoalDateRangeEnum.YearToDate,
            GoalDateRangeEnum.SpecificYear
        ],
        productivity: [
            GoalDateRangeEnum.Today,
            GoalDateRangeEnum.Yesterday,
            GoalDateRangeEnum.ThisWeek,
            GoalDateRangeEnum.LastWeek,
            GoalDateRangeEnum.LastMonth,
            GoalDateRangeEnum.ThisMonth,
            GoalDateRangeEnum.LastTwelveMonths,
            GoalDateRangeEnum.YearToDate,
            GoalDateRangeEnum.SpecificYear
        ],
        averageTicket: [
            GoalDateRangeEnum.Today,
            GoalDateRangeEnum.Yesterday,
            GoalDateRangeEnum.Tomorrow,
            GoalDateRangeEnum.ThisWeek,
            GoalDateRangeEnum.LastWeek,
            GoalDateRangeEnum.LastMonth,
            GoalDateRangeEnum.ThisMonth,
            GoalDateRangeEnum.YearToDate,
            GoalDateRangeEnum.SpecificYear
        ]
    }

    export const GOAL_CATEGORIES = [
        {
            id: GoalCategoryEnum.AverageTicket,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.averageTicket]
        },
        {
            id: GoalCategoryEnum.AverageServiceTicket,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.averageTicket]
        },
        {
            id: GoalCategoryEnum.AverageRetailTicket,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.averageTicket]
        },
        {
            id: GoalCategoryEnum.FrequencyOfVisit,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.ratings]
        },
        {
            id: GoalCategoryEnum.NewClientsPerMonth,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.ratings]
        },
        {
            id: GoalCategoryEnum.Rebook,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.rebook]
        },
        {
            id: GoalCategoryEnum.Retail,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.sales]
        },
        {
            id: GoalCategoryEnum.NewClientRetention,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.retention]
        },
        {
            id: GoalCategoryEnum.RepeatClientRetention,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.retention]
        },
        {
            id: GoalCategoryEnum.Service,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.sales]
        },
        {
            id: GoalCategoryEnum.Rating,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.ratings]
        },
        {
            id: GoalCategoryEnum.RequestRate,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.rates]
        },
        {
            id: GoalCategoryEnum.Membership,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.rates]
        },
        {
            id: GoalCategoryEnum.Productivity,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.productivity]
        },
        {
            id: GoalCategoryEnum.GiftCard,
            dateRanges: [...GOAL_CATEGORIES_DATERANGES.sales]
        }
    ];


    export interface IDashboardGoalColumn extends IGoalColumn {
        actualPercent?: number;
        percent?: number;
        dateRangeEnum: GoalDateRangeEnum;
        rebooked?: number;
        total?: number;
        goalDashboardBreakdown?: IDashboardGoalColumn[];
    }

    export interface IDashboardGoalModel {
        productivity?: IDashboardGoalColumn[];
        averageTicket?: IDashboardGoalColumn[];
        frequencyOfVisit?: IDashboardGoalColumn[];
        rebook?: IDashboardGoalColumn[];
        sales?: IDashboardGoalColumn[];
        newClient?: IDashboardGoalColumn[];
        fiveStarRating?: IDashboardGoalColumn[];
        requestRate?: IDashboardGoalColumn[];
        retention?: IDashboardGoalColumn[];
        membership?: IDashboardGoalColumn[];
    }

    class FilterObject implements IFilterObject {
        year;
        employeeId;
        departmentId;
        goalTypes;
        isDataView;

        constructor(options: FilterObject = <FilterObject>{}) {
            _.assign(this, {
                ...DEFAULT_FILTER_CRITERIA,
                ...options
            });
        }

        public getCriteria() {
            return {
                criteria: _.pick(this,
                    'year',
                    'employeeId',
                    'departmentId',
                    'goalTypes',
                    'isDataView'
                )
            }
        }
    }

    class DashboardGoalsController {
        static $inject = [
            '$rootScope',
            '$scope',
            '$state',
            '$q',
            '$translate',
            '$window',
            '$timeout',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.common.IdentityService',
            'meevo.components.busy.BusyService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.SecurityService'
        ];

        public filterCriteria: FilterObject;
        public dataViews: { label: string; value: ViewTypesEnum }[];

        public departmentList: any = [];
        public departmentId: any = 0;
        public departmentIdsList = [];
        public departmentBackupList: any;

        public employee: any;
        public defaultEmployeeId: Guid;
        public employeeCriteria = {
            includeActive: true,
            showEmployeesOnly: true,
            departmentId: ''
        };

        public goalsModel: IDashboardGoalModel;
        public clearedGoalsModel: IDashboardGoalModel;

        public locationStartYear: any;
        public _yearSelect: any = [];
        public _dateRangeSelect: any = GOAL_DATE_RANGES;


        public selectedView: ViewTypesEnum;
        public securityKeys = Meevo.Components.Common.SecurityKeys;
        public isFilterViewHidden: boolean = false;
        public printGoalsView: any = {
            averageTicket: false,
            sales: false,
            rebook: false,
            frequencyOfVisit: false,
            newClients: false,
            retention: false,
            fiveStarRating: false,
            requestRate: false
        };
        public viewAllEmployeesHide: boolean;
        public isApplyDisabled: boolean;
        public goalsSlider: boolean = false;
        public selectedDateRange: GoalDateRangeEnum = GoalDateRangeEnum.Today;
        protected appointmentBookSettings: Meevo.Model.AppointmentBookSettings;
        public departmentName: string = '--';

        constructor(protected $rootScope: ng.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: angular.ui.IState,
                    protected $q: angular.IQService,
                    protected $translate: angular.translate.ITranslateService,
                    private $window: angular.IWindowService,
                    private $timeout: angular.ITimeoutService,
                    protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected securityService: Meevo.Components.Common.ISecurityService
        ) {
            localStorage.removeItem('goalsModel');

            this.securityService.checkSecurityKey(this.securityKeys.GOALS_GOALSDASHBOARD_ACTION_VIEWALLEMPLOYEEGOALS)
                .then((securityCode: Meevo.Model.SecurityAccessEnum) => {
                    this.viewAllEmployeesHide = securityCode === Meevo.Model.SecurityAccessEnum.Hide;
                });

            this.filterCriteria = new FilterObject();

            this.dataViews = [...DATA_VIEWS];

            // Set default values to filter
            this.selectedView = ViewTypesEnum.Charts;

            this.$window = $window;

            this.getInitialDashboardGoals();

            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                if (toState.name === 'dashboardGoals') {
                    $timeout(() => {
                        const graphContainer = angular.element('.nvd3.nv-wrap')[0];
                        // Run resize on graph only when it is too small
                        if (graphContainer && graphContainer.getBoundingClientRect().width < 100) {
                            $window.dispatchEvent(new Event('resize'));
                        }
                    }, 300);
                }
            });
        }

        public getInitialDashboardGoals(): void {
            this.busyService.start();
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Tenant/Businessinfo`, 'GET', null).then((res: any) => {
                this.locationStartYear = res.data && res.data.implementationDate ? moment(res.data.implementationDate).year() : CURRENT_YEAR - 1;
            }).catch(() => {
                this.locationStartYear = CURRENT_YEAR - 1;
            }).finally(() => {
                let i = this.locationStartYear;
                while (i <= (CURRENT_YEAR + 1)) {

                    let year = {
                        id: i,
                        label: i
                    };
                    this._yearSelect.push(year);
                    i++;
                }
                this._yearSelect = this._yearSelect.reverse();
            });

            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Goal/Dashboard/Department/List`, 'POST', null).then((res: any) => {
                if (res.data.length > 0) {
                    _.each(res.data, (department: any) => {
                        this.departmentList.push(department);
                    });

                    this.departmentId = '';
                    this.departmentBackupList = angular.copy(this.departmentList);
                    this.filterCriteria.departmentId = this.departmentId;
                }

                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/employee/${this.identityService.current().userAuthId}`, 'GET', null).then((res: any) => {
                    if (res.data && res.data.displayName !== ', ') {
                        this.defaultEmployeeId = this.identityService.current().userAuthId;
                        this.employee = res.data;
                        this.filterCriteria.employeeId = this.defaultEmployeeId;

                        this.changeEmployee();
                    } else {
                        this.busyService.stop();
                    }
                }, (data: any) => {
                    this.busyService.stop();
                });

            });
        }

        get viewTypesEnum() {
            return ViewTypesEnum;
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);

            $('body').removeClass('goals-print');
            localStorage.removeItem('goalsModel');
        }

        public toggleFilterView = () => {
            this.isFilterViewHidden = !this.isFilterViewHidden;
        }

        public onGoalDateRangeChangeEvent(data: IFiterGoalType) {
            this.getDashboardGoals(data);
        }

        public getGoalsFromGlobalDateRange() {
            if ((this.employee || this.departmentId) && this.goalsModel) {
                this.getDashboardGoals();
            }
        }

        public getDashboardGoals(data?: IFiterGoalType): angular.IPromise<any> {
            this.collectCriteriaGoalTypes(data);

            if (this.filterCriteria.goalTypes.length > 0) {
                this.busyService.start();
                return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Goal/Dashboard`, 'POST', this.filterCriteria.getCriteria()).then((res: any) => {
                    let dataFromStorage = JSON.parse(localStorage.getItem('goalsModel')) || {},
                        dataFromCall = this.prepareGoalsModel(res.data);

                    if (_.isEmpty(dataFromStorage)) {
                        this.goalsModel = dataFromCall;
                    } else {
                        this.goalsModel = Object.keys(dataFromStorage)
                            .reduce((result: IDashboardGoalModel, key) => {
                                result[key] = [...(dataFromStorage[key] || []), ...(dataFromCall[key] || [])];
                                return result;
                            }, {});
                    }
                    localStorage.setItem('goalsModel', JSON.stringify(this.goalsModel));

                    this.busyService.stop();
                });
            }

        }


        public prepareGoalsModel(model: any): IDashboardGoalModel {

            let goalModel = <IDashboardGoalModel>{
                averageTicket: [],
                frequencyOfVisit: [],
                rebook: [],
                sales: [],
                newClient: [],
                fiveStarRating: [],
                requestRate: [],
                retention: [],
                membership: [],
                productivity: []
            };

            model.goalDashboard.forEach(goal => {
                switch (goal.goalCategory) {
                    case GoalCategoryEnum.AverageTicket:
                    case GoalCategoryEnum.AverageServiceTicket:
                    case GoalCategoryEnum.AverageRetailTicket:
                        goalModel.averageTicket.push(goal);
                        break;
                    case GoalCategoryEnum.FrequencyOfVisit:
                        goalModel.frequencyOfVisit.push(goal);
                        break;
                    case GoalCategoryEnum.Rebook:
                        goalModel.rebook.push(goal);
                        break;
                    case GoalCategoryEnum.Service:
                    case GoalCategoryEnum.Retail:
                    case GoalCategoryEnum.GiftCard:
                        goalModel.sales.push(goal);
                        break;
                    case GoalCategoryEnum.NewClientsPerMonth:
                        goalModel.newClient.push(goal);
                        break;
                    case GoalCategoryEnum.Rating:
                        goalModel.fiveStarRating.push(goal);
                        break;
                    case GoalCategoryEnum.RequestRate:
                        goalModel.requestRate.push(goal);
                        break;
                    case GoalCategoryEnum.NewClientRetention:
                    case GoalCategoryEnum.RepeatClientRetention:
                        goalModel.retention.push(goal);
                        break;
                    case GoalCategoryEnum.Membership:
                        goalModel.membership.push(goal);
                        break;
                    case GoalCategoryEnum.Productivity:
                        goalModel.productivity.push(goal);
                        break;
                }
            });

            return goalModel;
        }

        public changeYear(): void {
            localStorage.removeItem('goalsModel');
        }

        public changeView(): void {
            if (this.selectedView === ViewTypesEnum.DataOnly && this.employee && this.goalsModel) {
                this.getDashboardGoals();
            }
        }

        /**
         * Listeners
         *
         */
        public changeEmployee(): void {
            localStorage.removeItem('goalsModel');

            if (this.employee) {
                this.busyService.start();
                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/employee/${this.employee.id}`, 'GET', null).then((res: any) => {
                    this.isApplyDisabled = false;

                    if (res.data && res.data.departments.length > 0) {
                        this.departmentList = [];
                        _.forEach(res.data.departments, (department: any) => {
                            let chosenDepartment = _.findWhere(this.departmentBackupList, { id: department.departmentId });
                            if (chosenDepartment) {
                                this.departmentList.push(chosenDepartment);
                            }
                        });

                        if (this.departmentList.length > 0 && this.departmentId == '') {
                            this.departmentId = this.departmentList[0].id;
                        }
                    } else {
                        this.departmentList = this.employee.displayName ? [] : angular.copy(this.departmentBackupList);
                    }

                    this.busyService.stop();
                }).catch(() => {
                    this.isApplyDisabled = true;
                    });
            } else {
                this.departmentList = angular.copy(this.departmentBackupList);
            }
        }

        public collectCriteriaGoalTypes(data: IFiterGoalType) {
            let dataFromStorage = this.breakGoalsIntoArr();
            this.filterCriteria.goalTypes = [];

            if (data) {
                let repeatedGoal = dataFromStorage.find(goal => goal.dateRangeEnum === data.goalDateRange && goal.goalCategory === data.goalCategory);

                if (!repeatedGoal) {
                    this.filterCriteria.goalTypes.push(data);

                    if (data.goalCategory === GoalCategoryEnum.AverageTicket) {
                        this.filterCriteria.goalTypes.push({
                            goalCategory: GoalCategoryEnum.AverageRetailTicket,
                            goalDateRange: data.goalDateRange
                        });

                        this.filterCriteria.goalTypes.push({
                            goalCategory: GoalCategoryEnum.AverageServiceTicket,
                            goalDateRange: data.goalDateRange
                        });
                    }
                }
            } else {
                GOAL_CATEGORIES.forEach((category: any) => {
                    let goalType: IFiterGoalType = {},
                        goalDateRange = category.dateRanges.find(dateRange => this.selectedDateRange === dateRange);

                    if (this.selectedView === ViewTypesEnum.DataOnly) {
                        this.filterCriteria.isDataView = true;
                        category.dateRanges.forEach((range: GoalDateRangeEnum) => {
                            let repeatedGoal = dataFromStorage.find(goal => goal.dateRangeEnum === range && goal.goalCategory === category.id);

                            if (!repeatedGoal) {
                                goalType = {};

                                goalType.goalCategory = category.id;
                                goalType.goalDateRange = range;

                                this.filterCriteria.goalTypes.push(goalType);
                            }
                        });
                    } else {
                        this.filterCriteria.isDataView = false;
                        
                        goalType.goalDateRange = (goalDateRange || goalDateRange === GoalDateRangeEnum.SpecificYear) ? this.selectedDateRange : GoalDateRangeEnum.YearToDate;
                        
                        let repeatedGoal = dataFromStorage.find(goal => goal.dateRangeEnum === goalType.goalDateRange && goal.goalCategory === category.id);

                        if (!repeatedGoal) {
                            goalType.goalCategory = category.id;

                            this.filterCriteria.goalTypes.push(goalType);
                        }
                    }
                });

            }
        }

        public breakGoalsIntoArr(): IDashboardGoalColumn[] {
            let dataFromStorage = JSON.parse(localStorage.getItem('goalsModel')) || {},
                arr: IDashboardGoalColumn[] = [];

            for (let i in dataFromStorage) {
                dataFromStorage[i].forEach((goal: IDashboardGoalColumn) => {
                    arr.push(goal);
                });
            }

            return arr;
        }

        public changeDepartments(): void {
            localStorage.removeItem('goalsModel');
            this.employeeCriteria.departmentId = this.departmentId;
            this.departmentName = this.getDepartments(this.departmentId).displayName;
        }
        public getDepartments(deptId) {
            for (let i = 0; i < this.departmentList.length; i++) {
                let dept = this.departmentList[i];
                if (dept.id == deptId) {
                    return dept
                }
            }
        }

        /**
         * Called on filter change
         */
        public filterChanged(): void {
            this.filterCriteria.departmentId = this.departmentId;
            this.filterCriteria.employeeId = this.employee && this.employee.displayName ? this.employee.id : null;
            this.$scope.$broadcast('RESET_DATE_RANGE');
            this.getDashboardGoals();
        }

        public clearFilter(): void {
            this.filterCriteria.departmentId = '';
            this.filterCriteria.employeeId = '';
            this.employeeCriteria.departmentId = '';
            this.filterCriteria.year = CURRENT_YEAR;
            this.isApplyDisabled = false;
            if(!this.viewAllEmployeesHide) {
                this.employee = '';
                this.departmentId = '';
                this.departmentList = angular.copy(this.departmentBackupList);
            }

            this.emptyGoalsModel();
        }

        public apply(): void {

        }

        public emptyGoalsModel(): void {

            this.clearedGoalsModel = {
                averageTicket: [],
                frequencyOfVisit: [],
                rebook: [],
                sales: [],
                newClient: [],
                fiveStarRating: [],
                requestRate: [],
                retention: [],
                membership: [],
                productivity: []
            };

            for (const category in this.goalsModel) {
                for (const goal of (this.goalsModel[category] || [])) {
                    if (goal.amount) goal.amount = null;
                    if (goal.actualAmount) goal.actualAmount = null;
                    if (goal.unit) goal.unit = null;
                    if (goal.actualUnit) goal.actualUnit = null;
                    if (goal.percent) goal.percent = null;
                    if (goal.actualPercent) goal.actualPercent = null;
                    if (goal.rebooked) goal.rebooked = null;
                    if (goal.total) goal.total = null;

                    for (const breakdown of (goal.goalDashboardBreakdown || [])) {
                        if (breakdown.amount) breakdown.amount = null;
                        if (breakdown.actualAmount) breakdown.actualAmount = null;
                        if (breakdown.unit) breakdown.unit = null;
                        if (breakdown.actualUnit) breakdown.actualUnit = null;
                        if (breakdown.percent) breakdown.percent = null;
                        if (breakdown.actualPercent) breakdown.actualPercent = null;
                        if (breakdown.rebooked) breakdown.rebooked = null;
                        if (breakdown.total) breakdown.total = null;
                    }

                    this.clearedGoalsModel[category].push(goal);
                };
            }

            this.goalsModel = this.clearedGoalsModel;
        }
        /* Slide animation function */
        public sliderAnimation(): void {
                this.goalsSlider = !this.goalsSlider;    
        }

        /* Print */
        public printGoals(): void {
            if ($('.goal-plugin').length) {
                $('body').addClass('goals-print');
            }

            $('.goal-dasboard-item').addClass('hide-goals');

            const options: Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/dashboardGoals/modal/printGoalsModalTemplate.html',
                controller: 'meevo.plugins.dashboardGoals.PrintGoalsController',
                controllerAs: 'vm',
                clickOutsideToClose: true
            };
            this.modalService.showCustom(options).then((res: any) => {
                if (res) {

                    this.printGoalsView = res.criteria;

                    if (this.selectedView != ViewTypesEnum.Charts) {
                        res.criteria.averageTicket && $('.goal-dasboard__average-ticket').removeClass('hide-goals');
                        (res.criteria.serviceSales || res.criteria.retailSales || res.criteria.giftCard) && $('.goal-dasboard__sales').removeClass('hide-goals');
                        res.criteria.rebook && $('.goal-dasboard__rebook').removeClass('hide-goals');
                        res.criteria.frequencyOfVisit && $('.goal-dasboard__frequency-of-visit').removeClass('hide-goals');
                        res.criteria.newClients && $('.goal-dasboard__new-clients').removeClass('hide-goals');
                        res.criteria.fiveStarRating && $('.goal-dasboard__star-rating').removeClass('hide-goals');
                        res.criteria.requestRate && $('.goal-dasboard__request-rate').removeClass('hide-goals');
                        res.criteria.retention && $('.goal-dasboard__retention').removeClass('hide-goals');
                        res.criteria.memberships && $('.goal-dasboard__membership').removeClass('hide-goals');
                        res.criteria.productivity && $('.goal-dasboard__productivity').removeClass('hide-goals');
                    }
                    else {
                        res.criteria.averageTicket && $('.averageticket-sales-chart-tile').removeClass('hide-goals');
                        res.criteria.serviceSales && $('.service-sales-chart-tile').removeClass('hide-goals');
                        res.criteria.retailSales && $('.retail-sales-chart-tile').removeClass('hide-goals');
                        res.criteria.rebook && $('.rebook-chart-tile').removeClass('hide-goals');
                        res.criteria.frequencyOfVisit && $('.frequency-of-visit-chart-tile').removeClass('hide-goals');
                        res.criteria.newClients && $('.new-clients-per-month-tile').removeClass('hide-goals');
                        res.criteria.fiveStarRating && $('.fivestar-chart-tile').removeClass('hide-goals');
                        res.criteria.requestRate && $('.requestrate-chart-tile').removeClass('hide-goals');
                        res.criteria.retention && $('.retention-chart-tile').removeClass('hide-goals');
                        res.criteria.productivity && $('.productivity-chart-tile').removeClass('hide-goals');
                        res.criteria.memberships && $('.memberships-chart-tile').removeClass('hide-goals');
                        res.criteria.giftCard && $('.giftcard-sales-chart-tile').removeClass('hide-goals');
                    }


                    window.print();
                }
            });
        }

        public translateForPrint(point): string {
            let label;

            switch (point) {
                case 'view':
                    label = _.findWhere(this.dataViews, { value: this.selectedView }).label;
                    break;
                case 'department':
                    label = this.departmentId ? _.findWhere(this.departmentList, { id: this.departmentId })['displayName'] : 'LABEL_GOAL_INFO_NONE';
                    break;
                case 'employee':
                    label = this.employee ? this.employee.displayName : 'LABEL_GOAL_INFO_NONE';
                    break;
            }

            return this.$translate.instant(label);
        }
    }

    angular.module('meevo.plugins.dashboardGoals')
        .controller('meevo.plugins.dashboardGoals.DashboardGoalsController', DashboardGoalsController);
}
